import React from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

import MappingWindow from "../mapping/MappingWindow";

function FieldMappings() {
  const {
    mappings: {
      defaultMappings: { customer: mappings },
    },
    msbc: {
      loading: msbcLoading,
      msbcDropdownFields: { customer: msbcFields },
    },
    shopify: {
      loading: shopifyLoading,
      shopifyDropdownFields: { customer: shopifyFields },
    },
  } = useSelector((state) => state.mapping);

  return (
    <div>
      {shopifyLoading || msbcLoading ? (
        <div
          className="d-flex flex-row justify-content-center align-items-center my-3"
          style={{ height: "40vh" }}
        >
          <Spinner
            animation="border"
            variant="secondary"
            role="status"
            size="md"
          ></Spinner>
        </div>
      ) : (
        <div>
          {msbcFields &&
            msbcFields.length > 0 &&
            shopifyFields &&
            shopifyFields.length > 0 && (
              <MappingWindow
                mappings={mappings}
                msbcFields={msbcFields}
                shopifyFields={shopifyFields}
                mappingsFor="customer"
                notificationPath="contactFieldMappings"
                cmsPath="cmsContent.syncSettings.contact.fieldMappings"
              />
            )}
        </div>
      )}
    </div>
  );
}

export default FieldMappings;
